import Vue from 'vue'

export default Vue.extend({
  name: 'v-measurable',

  props: {
    height: [Number, String],
    maxHeight: [Number, String],
    maxWidth: [Number, String],
    minHeight: [Number, String],
    minWidth: [Number, String],
    width: [Number, String],
  },

  computed: {
    measurableStyles() {
      const styles = {}

      const height = this.convertToUnit(this.height)
      const minHeight = this.convertToUnit(this.minHeight)
      const minWidth = this.convertToUnit(this.minWidth)
      const maxHeight = this.convertToUnit(this.maxHeight)
      const maxWidth = this.convertToUnit(this.maxWidth)
      const width = this.convertToUnit(this.width)

      if (height) styles.height = height
      if (minHeight) styles.minHeight = minHeight
      if (minWidth) styles.minWidth = minWidth
      if (maxHeight) styles.maxHeight = maxHeight
      if (maxWidth) styles.maxWidth = maxWidth
      if (width) styles.width = width

      return styles
    },
  },
  methods: {
    convertToUnit (str, unit = 'px') {
      if (str == null || str === '') {
        return undefined
      } else if (isNaN(str)) {
        return String(str)
      } else {
        return `${Number(str)}${unit}`
      }
    }
  }
})
